/**
 * Play inline YouTube/Vimeo no poster (home Serviços GM, Sobre nós).
 * Clique no trigger → troca poster por iframe com autoplay
 * e scroll para o vídeo ficar 100% visível abaixo do navbar.
 */
(() => {
  const roots = document.querySelectorAll('[data-gm-video-inline]');
  if (!roots.length) return;

  const headerOffset = () => {
    const raw = getComputedStyle(document.body).getPropertyValue('--header-height').trim();
    const n = Number.parseFloat(raw);
    return Number.isFinite(n) ? n : 60;
  };

  const preferReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const scrollVideoIntoView = (root) => {
    const top = root.getBoundingClientRect().top + window.scrollY - headerOffset();
    window.scrollTo({
      top: Math.max(0, top),
      behavior: preferReducedMotion() ? 'auto' : 'smooth',
    });
  };

  const play = (root) => {
    if (root.classList.contains('is-playing')) return;

    const src = root.getAttribute('data-gm-video-src');
    if (!src) return;

    const title =
      root.querySelector('[data-gm-video-play]')?.getAttribute('aria-label') || 'Vídeo';

    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.title = title;
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.className = 'gm-video-placeholder__frame';

    root.replaceChildren(iframe);
    root.classList.add('is-playing');
    scrollVideoIntoView(root);
  };

  roots.forEach((root) => {
    const btn = root.querySelector('[data-gm-video-play]');
    if (!btn) return;
    btn.addEventListener('click', () => play(root));
  });
})();
